import { Container } from "@mui/material";
import { useContext } from "react";
import { ContentWrapper } from "../components/layout/ContentWrapper";
import { BottomActionBar } from "../components/utils/BottomActionBar";
import { SolutionCard } from "../components/view/SolutionCard";
import { routes } from "../constants/routes";
import { ContentfulContext } from "../context/ContentfulContext";
import { Solution, Solutions } from "../models/schema";

const SolutionsPage = () => {
  const { content } = useContext(ContentfulContext);
  const solutions = content?.solutions as Solutions;
  const { title, solutionsCollection, bottomBannerLabel, bottomBannerAction } = solutions;

  return (
    <>
      <ContentWrapper title={title as string} sx={{ pb: 10 }}>
        <Container
          sx={{ p: { xs: 0 }, display: "flex", flexDirection: "column", gap: { xs: 5, md: 10 } }}>
          {solutionsCollection?.items.map((solution, index) => (
            <SolutionCard key={index} solution={solution as Solution} />
          ))}
        </Container>
      </ContentWrapper>
      <BottomActionBar
        actionLabel={bottomBannerAction as string}
        title={bottomBannerLabel as string}
        route={routes.contact}
      />
    </>
  );
};

export default SolutionsPage;
